import { render, staticRenderFns } from "./ProductGroupList.vue?vue&type=template&id=0c03b034&"
import script from "./ProductGroupList.vue?vue&type=script&lang=js&"
export * from "./ProductGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports